import {
  AirDisruptionGuardsV1,
  CartGuards,
  CfarGuards,
  AirChfarGuards,
  ContactInformationGuards,
  FlightPassengerGuards,
  AirPFExerciseGuards,
  ReviewGuards,
  SeatGuards,
  VipSupportGuards,
  AirChfarExerciseDiscountGuards,
  getObjectKeysAsObject,
} from "@hopper-b2b/checkout";
import { AirPriceDropGuards } from "../states/AirPriceDrop/guards";
import { contactInformationGuards as uberContactInformationGuards } from "./contactInformation";
import { paymentGuards } from "./payment";

export const Guards = {
  ...AirChfarExerciseDiscountGuards,
  ...AirChfarGuards,
  ...AirDisruptionGuardsV1,
  ...AirPFExerciseGuards,
  ...CartGuards,
  ...CfarGuards,
  ...ContactInformationGuards,
  ...FlightPassengerGuards,
  ...paymentGuards,
  ...ReviewGuards,
  ...SeatGuards,
  ...VipSupportGuards,
  // Locally defined
  ...AirPriceDropGuards,
  // Overrides "contactContinue" from checkout lib
  ...uberContactInformationGuards,
};

export const GuardTypes = getObjectKeysAsObject(Guards);
